import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Field from '../../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../../helpers/numbers'

import { IMPRESSIONS } from '../../../../../../Multiplatform/UploadAdCreative/fields'
import { BUDGET_LIFETIME, BUDGET_OPTION } from '../../../../../../Multiplatform/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [IMPRESSIONS]

const ImpressionsStep = ({ formik, handleStepChange, remainingImpressions }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step
      stepTitle={'How many impressions would you like this new ad group to deliver?'}
      handleContinue={handleContinue}
    >
      <section className={drawerFormClasses.section}>
        <div className={drawerFormClasses.sectionTitle}>{t('Impressions')}</div>
        {/* Budget type selection is temporarily commented out, because for now we need only lifetime budget*/}
        {/*todo uncomment when needed*/}
        {/*<BudgetTypeField formik={formik} />*/}
        {values[BUDGET_OPTION] === BUDGET_LIFETIME && (
          // This sentence is only relevant if the budget type is lifetime
          <p>{t('An approximate number of impressions for the entire run-time of the ad group.')}</p>
        )}
        <p>{t(`Your remaining total is ${formatNumber(remainingImpressions)} impressions`)}</p>
        <Field
          type="number"
          formik={formik}
          name={IMPRESSIONS}
          placeholder={t('Lifetime impressions')}
          autoComplete="off"
          inputMode="numeric"
        />
      </section>
    </Step>
  )
}

export default ImpressionsStep
